export default (positionSize, quote, config) => positionSize >= config?.MINIMUM_QUOTE_AMOUNTS?.[quote];
